import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import AddrSearch from 'components/common/AddrSearch/AddrSearch';
import { notification, Table, Modal, Tooltip, Button, Input, Descriptions } from 'antd';
import { text_companyNm } from 'lib/textChang';
import { COMPANY_TYPE, CE_TYPE } from 'constant';

@inject(({ orderStore, commonStore }) => ({ 
  sessionLoginInfo: commonStore.sessionLoginInfo,

  lastOrder: orderStore.lastOrder,
  disLastOrder: orderStore.disLastOrder,
  addOrderList: orderStore.addOrderList,
  onChangValue: orderStore.onChangValue,
}))

@observer
class OrderModal extends Component {
  state = {
    modalOpenAddr: false,
    orAddr: '',			    // 주소
    orAddrDetail: '',	  // 상세주소
    orZipCd: '',		    // 우편번호
    picNm: '',			    // 담당자 성명
    picHp: '',			    // 담당자 연락처
    mgrUserId: '',		  // 인수자 사번
    mgrUserNm: '',		  // 인수자 성명
    mgrUserHp: '',		  // 인수자 연락처
    officeNm: '',		    // 회사 이름
    order_total: "0"	  // 총주문 금액
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // 벤츠는 마지막주문데이터 사용안함
    if (this.props.sessionLoginInfo?.cGbn !== COMPANY_TYPE.BENZ) {
      if (nextProps.modalOpen !== this.props.modalOpen) {
        if (nextProps.modalOpen === true) {
          this.props.disLastOrder();
        }
      }

      if (nextProps.lastOrder !== this.props.lastOrder) {
        if (nextProps.modalOpen === true) {
          this.setState({
            orAddr: nextProps?.lastOrder?.orAddr || '',
            orAddrDetail: nextProps?.lastOrder?.orAddrDetail || '',
            orZipCd: nextProps?.lastOrder?.orZipCd || '',
            picNm: nextProps?.lastOrder?.picNm || '',
            picHp: nextProps?.lastOrder?.picHp || '',
            mgrUserId: nextProps?.lastOrder?.mgrUserId || '',
            mgrUserNm: nextProps?.lastOrder?.mgrUserNm || '',
            mgrUserHp: nextProps?.lastOrder?.mgrUserHp || '',
            officeNm: nextProps?.lastOrder?.officeNm || ''
          });
        }
      }
    }
    this.totalMoney();
  }

  totalMoney = () => {
    let total = 0, caCnt = 0;

    this.props.cartList.map(item=>{return(       
      caCnt = caCnt + parseInt(item.caCnt)
    )});        
    this.props.cartList.map(item=>{return(
      total = total + parseInt(item.gdPrice)*parseInt(item.caCnt)
    )});
    this.setState({order_total: total});
  };

  fcOnOk = () => {
    const { orZipCd, orAddr, orAddrDetail, 
      picNm, picHp, mgrUserId, mgrUserNm, mgrUserHp, officeNm} = this.state;
    const { sessionLoginInfo } = this.props;

    if (orAddr === '' || orAddrDetail === '' || orZipCd === '') {
      notification.warning({placement: 'bottomLeft', message: `배송지를 확인해주세요.`, duration: 2});
      return false;
    }
      
    if (sessionLoginInfo.cGbn === COMPANY_TYPE.KNP) {
      if(officeNm === '') {
        notification.warning({placement: 'bottomLeft', message: `${text_companyNm()} 이름을 확인해주세요.`, duration: 2});
        return false;
      }
      
      if (picNm === '' || picHp === '') {
        notification.warning({placement: 'bottomLeft', message: `담당자 정보를 확인해주세요.`, duration: 2});
        return false;
      }  
      if (mgrUserId === '' || mgrUserNm === '' || mgrUserHp === '') {
        notification.warning({placement: 'bottomLeft', message: `인수자 정보를 확인해주세요.`, duration: 2});
        return false;
      } 
    } 
    
    if (sessionLoginInfo.cGbn === COMPANY_TYPE.BENZ) {
      if (picNm === '' || picHp === '') {
        notification.warning({placement: 'bottomLeft', message: `인수자 정보를 확인해주세요.`, duration: 2});
        return false;
      }  
    }
    // console.log("this.props.ceType", this.props.ceType);
    if (window.confirm(`주문하기 이후에 주문내역은 수정이 불가합니다. 주문 하시겠습니까? `)) {
      //원래 주문
        this.props.addOrderList({
          orAddr,
          orAddrDetail, 
          orZipCd, 
          picNm,
          picHp,
          mgrUserId, 
          mgrUserNm,
          mgrUserHp,
          officeNm,
          orStat: (this.props.ceType === CE_TYPE.MASTER 
            || (this.props.cGbn === COMPANY_TYPE.BENZ && this.props.ceType === CE_TYPE.BRANCH) )
              ? "2" : "1"
        });              
    }
  }

  render() {
    const { modalOpenAddr, orZipCd, orAddr, orAddrDetail, 
      picNm, picHp, mgrUserId, mgrUserNm, mgrUserHp, officeNm, order_total} = this.state;
    const { sessionLoginInfo } = this.props;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '상품명', dataIndex: 'gdNm', align: 'center' },
      { title: '사원명', dataIndex: 'dresserNm', width: 130, align: 'center' },
      { title: '사이즈', dataIndex: 'caGdSize', width: 100, align: 'center',
        render: (item, record) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.caEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'caCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'gdPrice', width: 150, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.caCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      }
    ];

    return (
      <Modal
        width={1300}
        title="주문하기"
        cancelText={"취소"}
        okText={"주문하기"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onOk={this.fcOnOk}
      >
        <div className="order_modal_p">
          <table className="table_st_wrap">
            <tbody>
              <tr>
                <th rowSpan="2">발송지</th>
                <td>
                  <Button 
                    type="primary"
                    onClick={()=>this.setState({modalOpenAddr: true})}
                  >우편번호 검색</Button>
                  <p>
                    <b>우편번호</b>
                    <span className="prog_input" style={{ width: '100px' }}>{orZipCd}</span>
                    <b>주소</b>
                    <span className="prog_input">{orAddr}</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><b>상세주소</b></p>
                  <Input
                    style={{ width: '50%' }}
                    value={orAddrDetail}
                    onChange={(e)=>this.setState({orAddrDetail: e.target.value })}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <Descriptions column={4} bordered >
            <Descriptions.Item 
              label={(sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ) 
                ? "인수자"  : "담당자 성명"}
              span={1}
            >
              <Input
                value={picNm}
                onChange={(e)=>this.setState({picNm: e.target.value })}
              />
            </Descriptions.Item>
            <Descriptions.Item 
              label={(sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ) 
                ? "연락처"  : "담당자 연락처"}
              span={3}
            >
              <Input
                value={picHp}
                onChange={(e)=>this.setState({picHp: e.target.value })}
              />
            </Descriptions.Item>
            {(sessionLoginInfo?.cGbn === COMPANY_TYPE.KNP) 
            && <Fragment>   
                <Descriptions.Item
                  label={"인수자 성명"}
                  span={1}
                >
                  <Input
                    value={mgrUserNm}
                    onChange={(e)=>this.setState({mgrUserNm: e.target.value })}
                  />
                </Descriptions.Item>
                <Descriptions.Item
                  label={"인수자 사번"}
                  span={1}
                >
                  <Input
                    value={mgrUserId}
                    onChange={(e)=>this.setState({mgrUserId: e.target.value })}
                  />
                </Descriptions.Item>
                <Descriptions.Item
                  label={"인수자 연락처"}
                  span={2}
                >
                  <Input
                    value={mgrUserHp}
                    onChange={(e)=>this.setState({mgrUserHp: e.target.value })}
                  />
                </Descriptions.Item>
                <Descriptions.Item label={text_companyNm() + " 이름"} span={4}>
                  <Input
                    value={officeNm}
                    onChange={(e)=>this.setState({officeNm: e.target.value })}
                  />
                </Descriptions.Item>
              </Fragment>  
            }
          </Descriptions>
        </div>
        {/* 금액 */}
        <div className="order_p_total">
          <div>총 <span className="num"> {this.props.cartList.length}</span>건 </div>
          <div>총 주문액 <span className="num">{order_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>원</div>
        </div>
        
        {/* 장바구니 목록 */}
        <Table 
          rowKey={(record)=>record.RNUM}
          columns={(sessionLoginInfo?.cGbn === COMPANY_TYPE.KNP) 
            ? columns.filter(item=> item?.dataIndex !== 'dresserNm')
            : columns
          }
          dataSource={this.props.cartList}
          pagination={false}
          scroll={{ y: 300 }}
        />
        <div className="last_chk_text02">
          <b>주문 하시겠습니까?</b>
          <br />
          (단, 주문 이후에 주문내역은 수정이 불가합니다.)<br/>
        </div>

        {/* 우편번호 검색 */}
        <AddrSearch
          modalOpen={modalOpenAddr}
          modalClose={()=>this.setState({modalOpenAddr: false})}
          setAddrInfo={(data)=>{
            this.setState({ orAddr: data.addr, orZipCd: data.orZipCd });
          }}
        />
      </Modal>
    );
  }
}

export default withRouter(OrderModal);

